import { NoteManager } from '../../../../managers/note.manager';
import { Note } from '../../../../models/domain/note';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { NoteDetailsBasicComponent } from '../note.details.basic/note.details.basic.component';
import { ssApiService } from '../../../../services/ss-api.service';
import { ManagerModeTypes } from '../../../../managers/manager.base';

@Component({
    selector: 'note-details-full',
    templateUrl: './note.details.full.component.html',
    styleUrls: ['./note.details.full.component.css']
})
export class NoteDetailsFullComponent implements OnInit {

    // viewchild
    @ViewChild(forwardRef(() => NoteDetailsBasicComponent))
    private noteDetail: NoteDetailsBasicComponent;

    // titles
    private dialogSaveEditTitleNote: string = 'Note Edited';
    private dialogSaveEditNoteSubTitle: string = 'Do you want to save this note before leaving?';

    // busy
    public IsBusy: boolean = false;
    public showSave: boolean = true;

    // managers
    @Input('NoteManager') NoteManager = new NoteManager(null);


    // tabs
    public HistoryTabIndex: number = 1;
    private activeTabIndex: number = 0;

    constructor(private api: ssApiService, private sweetAlertService: SweetAlertService) {

    }

    ngOnInit() {
        // this.noteField.nativeElement.focus();
    }


    SelectNote(note: Note) {
        // this.NoteManager.AllNotes()[0].Created
        // not edited
        if (!this.NoteManager.Edited()) {
            this.SelectNoteActive(note);
            return;
        }


        // edited
        // dialog
        this.SaveConfirm(
            this.NoteManager.Note(),

            // on save
            () => {
                // save note and navigate after saved
                let saved = this.NoteManager.OnChangesSaveResponse.subscribe(response => {
                    saved.unsubscribe();
                    this.SelectNoteActive(note);
                })

                this.NoteManager.SaveChanges(false, true);
            },

            // on cancel
            () => {
                this.NoteManager.UndoChanges();
                this.SelectNoteActive(note);
            }
        );

    }


    SaveActiveNote() {

        let saved = this.NoteManager.OnChangesSaveResponse.subscribe(response => {
            saved.unsubscribe();
        })

        this.NoteManager.SaveChanges(false, true);

    }

    SelectNoteActive(note: Note) {

        this.NoteManager.SelectNoteToEditByID(note.ID);
        this.noteDetail.CalculateRemainingNoteCharacters();

        if (this.activeTabIndex == this.HistoryTabIndex)
            this.NoteManager.LoadHistory();

    }


    ShowHistoryTab() {
        return (this.NoteManager.ModeType() == ManagerModeTypes.Add) ? false : true;
    }

    TabChanged(e: any) {

        this.activeTabIndex = e.index;

        if (e.index == 1) {
            // history
            this.NoteManager.LoadHistory();
            this.showSave = false;
        } else {
            this.showSave = true;
        }
    }


    confirm() {

        let saved = this.NoteManager.OnChangesSaveResponse.subscribe(response => {
            saved.unsubscribe();
        })

        this.NoteManager.SaveChanges(false, true);
    }

    SaveConfirm(note: Note, actionAfterSave: any, actionAfterCancel: any) {

        // edited
        this.sweetAlertService.swal({
            title: this.dialogSaveEditTitleNote,
            text: this.dialogSaveEditNoteSubTitle,
            type: 'warning',
            showCancelButton: true,
            showCloseButton: false,
            confirmButtonText: 'Yes, save!',
            cancelButtonText: 'No, cancel',
            allowOutsideClick: false
        }).then(

            // save
            () => {
                actionAfterSave();
            },

            // cancel
            (dismiss) => {
                if (dismiss === 'cancel') {
                    actionAfterCancel();
                }
            })

    }



}
